import {useCallback, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {fabric} from 'fabric';
import {
  selectInitEnvelopeStickers,
  selectHasStickersChanged,
} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {RESET_DESIGN_OPTIONS} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';
import {EventCreateStampContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Stamp/EventCreateStampContext';

export const useStickers = () => {
  const dispatch = useDispatch();
  const initStickers = useSelector(selectInitEnvelopeStickers);
  const hasStickersChanged = useSelector(selectHasStickersChanged);
  const {canvas} = useContext(EventCreateStampContext);

  const onStickersReset = useCallback(async () => {
    canvas.loadFromJSON({objects: initStickers?.objects, version: fabric.version}, null, () => {});

    dispatch({
      type: RESET_DESIGN_OPTIONS,
      payload: ['envelopeStickers'],
    });
  }, [canvas, initStickers?.objects]);

  return {onStickersReset, hasStickersChanged};
};
